module.exports = __webpack_public_path__ + "img/reparo.dde53ecb.svg";